<!-- @format -->

<template>
  <b-card class="mb-3">
    <b-modal
      id="getActiveTeamTp"
      ref="modal"
      title="TP查看"
    >
      <b-table :fields="getTeamTpFiele" :items="getTeamTp" empty-text="暂无数据" show-empty />
    </b-modal>
    <div class="m-2">
      <b-row>
        <b-col md="2" class="mb-2">
          <div class="d-flex align-items-center">
            <span style="width: 45px;">每页:</span>
            <b-form-select v-model="pageSize" :options="options" size="sm" />
          </div>
        </b-col>
        <b-col md="3" class="mb-2">
          <div class="d-flex align-items-center">
            <span style="width: 85px; flex-shrink: 0;">Start Date:</span>
            <flat-pickr
              id="startDatePicker"
              v-model="start_time"
              class="form-control form-control-sm"
              placeholder="mm/dd/yyyy"
              :config="datePickerConfig"
              @on-change="onStartDateChange"
            />
          </div>
        </b-col>
        <b-col md="3" class="mb-2">
          <div class="d-flex align-items-center">
            <span style="width: 80px; flex-shrink: 0;">End Date:</span>
            <flat-pickr
              id="endDatePicker"
              v-model="end_time"
              class="form-control form-control-sm"
              placeholder="mm/dd/yyyy"
              :config="datePickerConfig"
              @on-change="onEndDateChange"
            />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col md="4" class="mb-2">
          <b-form-input v-model="id" size="sm" placeholder="Member id" />
        </b-col>
        <b-col md="4" class="mb-2">
          <b-form-input v-model="real_name" size="sm" placeholder="Member name" />
        </b-col>
      </b-row>
      <b-tabs content-class="mt-1" @input="chan">
      <b-tab title="个人TP">
        <div class="total-active-tp">
          <strong style="font-size: 1.5em;">Total Active TP: {{ totalActiveTP }}</strong>
  </div>
        <b-table :fields="itemsPerson" :items="itemsPersonItem" empty-text="暂无个人TP数据" show-empty />
      </b-tab>
      <b-tab title="基础团队TP">

        <b-table :fields="itemsPerson2" :items="itemsPersonItem" empty-text="暂无基础团队TP数据" show-empty>
          <!--          解构active_tp -->
          <template #cell(active_tp)="data">
            <div class="font-weight-bold" @click="getActiveTeamTp(data)"> {{ data.value }}</div>
          </template>

        </b-table>
        <!--   弹窗     -->
      </b-tab>
      <b-tab title="超级团队TP">
        <b-table :fields="itemsPerson2" :items="itemsPersonItem" empty-text="暂无超级团队TP数据" show-empty>
          <template #cell(active_tp)="data">
            <div class="font-weight-bold" @click="getActiveTeamTp(data)"> {{ data.value }}</div>
          </template>
        </b-table>
      </b-tab>
      <b-tab title="无限团队TP">
        <b-table :fields="itemsPerson2" :items="itemsPersonItem" empty-text="暂无 无限团队TP 数据" show-empty>
          <template #cell(active_tp)="data">
            <div class="font-weight-bold" @click="getActiveTeamTp(data)"> {{ data.value }}</div>
          </template>
        </b-table>
      </b-tab>
    </b-tabs>
    <b-pagination v-model="currentPage" :total-rows="total" :per-page="paginationPerPage" aria-controls="my-table" class="my-0" align="center" />
    </div>
  </b-card>
</template>

<script>
import { BTabs, BTab, BCard, BTable, BFormSelect, BPagination } from 'bootstrap-vue'
import flatPickr from 'vue-flatpickr-component'
import { computed, getCurrentInstance, reactive, ref, watch } from '@vue/composition-api'
import axiosIns from '@/libs/axios'

const formatDateForApi = value => {
  if (!value) return ''
  const trimmed = String(value).trim()
  const isoMatch = trimmed.match(/^(\d{4})-(\d{2})-(\d{2})$/)
  if (isoMatch) {
    const [, year, month, day] = isoMatch
    return `${month}/${day}/${year}`
  }
  return trimmed
}

export default {
  components: {
    BTabs,
    BTab,
    BTable,
    BCard,
    BFormSelect,
    BPagination,
    flatPickr,
  },
  setup() {
    const { proxy } = getCurrentInstance()
    const itemsPerson = [
      {
        key: 'key',
        label: '排名',
      },
      {
        key: 'real_name',
        label: '姓名',
      },
      {
        key: 'active_tp',
        label: '生效TP',
      },
      {
        key: 'pid',
        label: '上线ID',
      },
      {
        key: 'parent_name',
        label: '上线姓名',
      },
    ]
    const itemsPerson2 = [
      {
        key: 'id',
        label: '排名',
      },
      {
        key: 'real_name',
        label: '队长',
      },
      {
        key: 'active_tp',
        label: '团队生效TP',
      },
      {
        key: 'pid',
        label: '上线ID',
      },
      {
        key: 'parent_name',
        label: '上线会员姓名',
      },
    ]
    const itemsPersonItem = ref([])

    const normalTeamTp = [
      {
        key: 'id',
        label: '排名',
      },
      {
        key: 'name',
        label: '姓名',
      },
      {
        key: 'tp',
        label: 'TP',
      },
      {
        key: 'action',
        label: '操作',
      },
    ]

    const superTeamTp = [
      {
        key: 'id',
        label: '排名',
      },
      {
        key: 'name',
        label: '姓名',
      },
      {
        key: 'tp',
        label: 'TP',
      },
      {
        key: 'action',
        label: '操作',
      },
    ]

    const travTeamTp = [
      {
        key: 'id',
        label: '排名',
      },
      {
        key: 'name',
        label: '姓名',
      },
      {
        key: 'tp',
        label: 'TP',
      },
      {
        key: 'action',
        label: '操作',
      },
    ]

    const getTeamTpFiele = [
      {
        key: 'id',
        label: '排名',
      },
      {
        key: 'real_name',
        label: '姓名',
      },
      {
        key: 'tp',
        label: '生效tp',
      },

    ]

    const tabs = reactive([
      { title: '个人TP', content: 'Tab 1 content' },
      { title: '基础团队TP', content: 'Tab 2 content' },
      { title: '超级团队TP', content: 'Tab 3 content' },
      { title: '无限团队TP', content: 'Tab 3 content' },
    ])

    const datePickerConfig = {
      altInput: true,
      altFormat: 'm/d/Y',
      dateFormat: 'Y-m-d',
    }

    const pageSize = ref(null)
    const currentPage = ref(1)
    const total = ref(0)
    const paginationPerPage = computed(() => pageSize.value || 200)
    const options = [
      { value: null, text: '' },
      { value: 10, text: '10' },
      { value: 20, text: '20' },
      { value: 50, text: '50' },
      { value: 100, text: '100' },
    ]
    const totalActiveTP = ref(0)
    const start_time = ref('')
    const end_time = ref('')
    const id = ref('')
    const real_name = ref('')
    const cate_id = ref('')
    const buildParams = () => ({
      cate_id: cate_id.value,
      start_date: formatDateForApi(start_time.value),
      end_date: formatDateForApi(end_time.value),
      page_size: pageSize.value || 200,
      page: currentPage.value,
      id: id.value,
      real_name: real_name.value,
    })

    const fetchData = () => {
      axiosIns
        .get('order/tp-all', { params: buildParams() })
        .then(res => {
          itemsPersonItem.value = res.data?.list
          total.value = res.data?.total
          totalActiveTP.value = res.data?.totalActiveTP
        })
    }

    const onStartDateChange = (selectedDates, dateStr) => {
      start_time.value = dateStr || ''
      currentPage.value = 1
      fetchData()
    }

    const onEndDateChange = (selectedDates, dateStr) => {
      end_time.value = dateStr || ''
      currentPage.value = 1
      fetchData()
    }

    watch([pageSize, id, real_name, currentPage], () => {
      fetchData()
    })

    const getTeamTp = ref([])
    const getActiveTeamTp = data => {
      getTeamTp.value = []
      const params = {
        user_id: data.item.user_id,
        cate: cate_id.value,
        start_date: formatDateForApi(start_time.value),
        end_date: formatDateForApi(end_time.value),
      }
      axiosIns
        .get('order/click-get-tp', { params })
        .then(res => {
          getTeamTp.value = res.data
          proxy.$bvModal.show('getActiveTeamTp')
        })
    }

    const chan = val => {
      cate_id.value = val + 1
      itemsPersonItem.value = []
      fetchData()
    }

    chan(0)

    return {
      getTeamTpFiele,
      getTeamTp,
      getActiveTeamTp,
      cate_id,
      currentPage,
      total,
      fetchData,
      options,
      datePickerConfig,
      id,
      real_name,
      start_time,
      end_time,
      tabs,
      chan,
      pageSize,
      paginationPerPage,
      onStartDateChange,
      onEndDateChange,

      itemsPerson,
      itemsPersonItem,
      itemsPerson2,

      normalTeamTp,
      superTeamTp,
      travTeamTp,

      totalActiveTP,
    }
  },
}
</script>

<style></style>
